import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import {Router} from "@angular/router";
import moment from 'moment';
import { BsModalService } from "ngx-bootstrap/modal";
import { AlertBannerService, AlertType } from "../../lib/alert-banner";
import {PermissionsService} from "../../services/permissions/permissions.service";
import {RequestsService} from "../../services/requests/requests.service";
import {RequestService} from "../../services/request/request.service";
import { ConstantsService } from 'src/app/services/constants/constants.service';


@Component({
  selector: 'app-backgroundchecks',
  templateUrl: './backgroundchecks.component.pug',
  styleUrls: ['./backgroundchecks.component.scss'],
  standalone: false
})
export class BackgroundChecksComponent implements OnInit, OnChanges {
  noFilterData = true;
  TRUST_752_VERIFICATION = false;
  TrustEIVC = false;
  canViewBackgroundCheckTab = true;

  constructor(
    private modalService: BsModalService,
    private alertList: AlertBannerService,
    private requests: RequestsService,
    public requestService: RequestService,
    private router: Router,
    private permissions: PermissionsService
  ) { }

  @Input() searchOption: any = undefined;
  @Input() rowsPerView = 20;
  @Input() currentPage = 1;
  @Input() sortString = '-created';
  @Input() filterOutput: any;
  @Output() outputNoData = new EventEmitter();
  @Output() outputLoading = new EventEmitter();
  @Output() outputTotal = new EventEmitter();
  @Output() outputSortOptions = new EventEmitter();
  @Output() outputFilterStatusOptions = new EventEmitter();
  @Output() outputNoFilterData = new EventEmitter();
  canViewBackGroundReport = false;

  sortOptions = [
    {
      'label': $localize`Recipient`,
      'type': "word",
      'value': "first_name"
    },
    {
      'label': $localize`Requested by`,
      'type': "word",
      'value': "created_by__first_name"
    },
    {
      'label': $localize`Send date`,
      'type': "number",
      'value': "created"
    }
  ];

  filterStatusOptions = [
    { 'label': $localize`Sending`, 'value': 'Trust Created' },
    { 'label': $localize`In progress`, 'value': 'Trust Sent' },
    { 'label': $localize`Completed`, 'value': 'Trust Completed' },
    { 'label': $localize`Failed`, 'value': 'Trust Failed' },
    { 'label': $localize`Expired`, 'value': 'Trust Expired' },
    { 'label': $localize`Cancelled`, 'value': 'Trust Cancelled' },
    { 'label': $localize`Declined`, 'value': 'Trust Declined' },
  ];

  filterStatusOptionsChecks = [
    { 'label': $localize`Sending`, 'value': 'Trust Created' },
    { 'label': $localize`In progress`, 'value': 'Trust Sent' },
    { 'label': $localize`Completed`, 'value': 'Trust Completed' },
    { 'label': $localize`Purged`, 'value': 'Trust Purged' },
    { 'label': $localize`Failed`, 'value': 'Trust Failed' },
    { 'label': $localize`Expired`, 'value': 'Trust Expired' },
    { 'label': $localize`Cancelled`, 'value': 'Trust Cancelled' },
    { 'label': $localize`Declined`, 'value': 'Trust Declined' },
  ];

  filterMapingStatusOptions = [
    { 'label': $localize`Sending`, 'value': 'Trust Created' },
    { 'label': $localize`In progress`, 'value': 'Trust Sent' },
    { 'label': $localize`In progress`, 'value': 'Trust In Progress' },
    { 'label': $localize`Completed`, 'value': 'Trust Completed' },
    { 'label': $localize`Failed`, 'value': 'Trust Failed' },
    { 'label': $localize`Expired`, 'value': 'Trust Expired' },
    { 'label': $localize`Cancelled`, 'value': 'Trust Cancelled' },
    { 'label': $localize`Declined`, 'value': 'Trust Declined' },
  ];

  MappedStatusOptions = [
    { 'label': 'Sending', 'value': 'Trust Created' },
    { 'label': 'In progress', 'value': 'Trust Sent' },
    { 'label': 'In progress', 'value': 'Trust In Progress' },
    { 'label': 'Completed', 'value': 'Trust Completed' },
    { 'label': 'Failed', 'value': 'Trust Failed' },
    { 'label': 'Expired', 'value': 'Trust Expired' },
    { 'label': 'Cancelled', 'value': 'Trust Cancelled' },
    { 'label': 'Declined', 'value': 'Trust Declined' },
  ];

  MappedStatusOptionsChecks = [
    { 'label': 'Sending', 'value': 'Trust Created' },
    { 'label': 'In progress', 'value': 'Trust Sent' },
    { 'label': 'In progress', 'value': 'Trust In Progress' },
    { 'label': 'Completed', 'value': 'Trust Completed' },
    { 'label': 'Failed', 'value': 'Trust Failed' },
    { 'label': 'Expired', 'value': 'Trust Expired' },
    { 'label': 'Cancelled', 'value': 'Trust Cancelled' },
    { 'label': 'Declined', 'value': 'Trust Declined' },
    { 'label': 'Purged', 'value': 'Trust Purged' },
  ];

  toolTipOptions = [
    {'label': '', 'value': 'Trust Created'},
    {'label': $localize`The background check has been sent to the recipient.`, 'value': 'Trust In Progress'},
    {'label': $localize`The background check has been sent to the recipient.`, 'value': 'Trust Sent'},
    {'label': $localize`Sending failed. Please send a new background check.`, 'value': 'Trust Failed'},
    {'label': '', 'value': 'Trust Completed'},
    {'label': $localize`The recipient has declined to provide consent for the background check.`, 'value': 'Trust Declined'},
    {'label': $localize`The background check has been cancelled.`, 'value': 'Trust Cancelled'},
    {'label': $localize`The recipient did not submit the required information to the vendor before the cutoff date.`, 'value': 'Trust Expired' }
  ];

  toolTipOptionsChecks = [
    {'label': '', 'value': 'Trust Created'},
    {'label': $localize`The background check has been sent to the recipient.`, 'value': 'Trust In Progress'},
    {'label': $localize`The background check has been sent to the recipient.`, 'value': 'Trust Sent'},
    {'label': $localize`Sending failed. Please send a new background check.`, 'value': 'Trust Failed'},
    {'label': '', 'value': 'Trust Completed'},
    {'label': $localize`The recipient has declined to provide consent for the background check.`, 'value': 'Trust Declined'},
    {'label': $localize`The background check has been cancelled.`, 'value': 'Trust Cancelled'},
    {'label': $localize`The recipient did not submit the required information to the vendor before the cutoff date.`, 'value': 'Trust Expired' },
    {'label': $localize`The background check has been removed by the vendor to comply with legal requirements and is no longer accessible.`, 'value': 'Trust Purged' },
  ];

  subStatusTooltips = {
    delayed: $localize`Processing of this background check is delayed as it is undergoing manual review.`,
    dco: $localize`This background check has been flagged for your review.`,
    purged: $localize`The background check has been removed by the vendor to comply with legal requirements and is no longer accessible.`,
  }
  requestsData: any;
  loading = true;
  total = 5;
  initialDataRequest = true;
  noData = false;

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.TRUST_752_VERIFICATION = this.permissions.isFeatureActivated('trust-752-certn-checks');
    this.TrustEIVC = this.permissions.isFeatureActivated('trust-892-eivc');
    this.canViewBackgroundCheckTab = (this.permissions.hasPermission('can_view_backgroundcheck_requests_list') || this.permissions.hasPermission('can_view_backgroundcheck_requests_list_with_survey_perms') || this.permissions.hasPermission('can_view_own_backgroundcheck_requests_list'));
    if (!this.canViewBackgroundCheckTab) {
      this.loading = false;
    }

    if (this.canViewBackgroundCheckTab) {
      this.initialiseData();
      this.emitToParent();
    }
    this.canViewBackGroundReport = (
      this.permissions.hasPermission('can_manage_backgroundcheck_requests') ||
      this.permissions.hasPermission('can_manage_backgroundcheck_requests_with_survey_perms') ||
      this.permissions.hasPermission('can_manage_own_backgroundcheck_requests') ||
      this.permissions.hasPermission('can_manage_support_background_checks')
    )

    if(this.TrustEIVC){
        this.MappedStatusOptionsChecks[4].label = 'Error'
        this.filterStatusOptionsChecks[4].label = $localize`Error`
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.initialDataRequest &&
      (changes.searchOption || changes.rowsPerView || changes.currentPage || changes.sortString || changes.filterOutput)) {
        this.initialiseData();
        this.emitToParent();
    }
  }

  initialiseData() {
    this.initialDataRequest = this.areDefaultValues()
    this.loading = true;

    this.requests.getChecksRequestsParams(this.searchOption, this.rowsPerView, this.currentPage, this.sortString, this.filterOutput).subscribe(

      (res) => {
        this.requestsData = res.data.external_checks;
        this.total = res.data.total;
        // if first/initial data request returns no data, means the page has no data at all, so show
        // noData image, don't show in any other circumstance eg. searches etc.
        if (this.total < 1 && this.initialDataRequest) {
          this.noData = true;
        } else {
          this.convertData();
          this.initialDataRequest = false;
        }
        if (!this.initialDataRequest){
          this.noData = false

        }
        this.noFilterData = !this.initialDataRequest && this.requestsData.length < 1 && !this.noData;
        this.loading = false;
        this.emitToParent();
      }, error => {
        console.log(error);
        this.initialDataRequest = false;
        if (error.status != 403) {
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        }
        this.loading = false;
        this.emitToParent();
      });
  }

  emitToParent() {
    this.outputLoading.emit(this.loading);
    this.outputTotal.emit(this.total);
    this.outputNoData.emit(this.noData);
    this.outputSortOptions.emit(this.sortOptions);
    this.outputFilterStatusOptions.emit(this.filterStatusOptionsChecks);
    this.outputNoFilterData.emit(this.noFilterData);
  }

  convertData(){
    this.requestsData.forEach(request => {
      if (request.requested_date) {
        let requested_date = moment(request.requested_date);
        request.requested_date_formatted = requested_date.format('ll');
      }
      if (request.candidate) {
        let initials = request.candidate.split(' ');
        let arrFiltered = initials.filter(el => {
          return el != null && el != '';
        });
        if (arrFiltered.length >= 2) {
          request.initials = arrFiltered[0][0] + arrFiltered[1][0];
        } else {
          request.initials = arrFiltered[0][0];
        }
      }
      if (request.check_name?.short_name.startsWith('id')){
        request.check_name.name = 'MobileID - '+ request.check_name.name
      }
      if (request.check_name?.short_name === ConstantsService.NCC_BANKRUPTCY_SHORT_NAME){
          request.check_name.name = 'Bankruptcy Check'
      }

      this.setStatusColour(request);
      if(request?.sub_state?.purged){
        request.state = 'Trust Purged'
      }
      request.toolTip = this.toolTipOptionsChecks.find(obj => obj.value === request.state)?.label
      request.state =  this.MappedStatusOptionsChecks.find(obj => obj.value === request.state)?.label
    });
  }

  setStatusColour(request) {
    let status = request.state.toLowerCase();
    if (status === 'trust completed') {
      request.status_colour = 'green';
    }
    else if (status === 'trust in progress' || status === 'trust sent') {
      request.status_colour = 'yellow';
    }
    else if (status === 'trust declined' || status === 'trust cancelled') {
      request.status_colour = 'red';
    }
    else if (status) {
      request.status_colour = 'grey';
    }
  }

  openCheck(report_url) {
    window.open(report_url, "_blank");
    return;
  }
  openBackgroundCheckReport(url:string, check_short_name:string, person_uid:string) {
    this.requestService.getPDFReport(url, check_short_name, person_uid.substring(0,8))
  }

  viewBackgroundCheck(request){
    if(request.state==$localize`In progress` || request.state==$localize`Completed`){
      return true
    }
    return false
  }
  tagClass(request){
    let type;
    if(request.status_colour === 'red') {type = 'cherry'}
    else if (request.status_colour === 'green') {type = 'forest'}
    else if (request.status_colour === 'yellow') {type = 'amber'}
    else if (request.status_colour === 'grey') {type = 'default-stat-tag'}
    return type
  }
  updateTooltipPos($event){
      let a = document.getElementsByClassName('bs-tooltip-top')
      if (a.length > 0) {
        let b = a[0] as HTMLElement
        b.classList.add('background-check-tooltip-top')
      }
  }


  protected readonly event = event;

  getLabelByValue(value:string){


    if(this.TrustEIVC){
        const STATUS_OPTIONS_CHECKS = [
          { 'label': $localize`Invited`, 'value': 'Invited' },
          { 'label': $localize`In progress`, 'value': 'In progress' },
          { 'label': $localize`Submitted`, 'value': 'Submitted' },
          { 'label': $localize`Verified`, 'value': 'Verified' },
          { 'label': $localize`Declined`, 'value': 'Declined' },
          { 'label': $localize`Expired`, 'value': 'Expired' },
          { 'label': $localize`Completed`, 'value': 'Completed' },
          { 'label': $localize`Requested`, 'value': 'Requested' },
          { 'label': $localize`Deleted`, 'value': 'Deleted' },
          { 'label': $localize`Stopped`, 'value': 'Stopped' },
          { 'label': $localize`Scheduled`, 'value': 'Scheduled' },
          { 'label': $localize`Sending`, 'value': 'Sending' },
          { 'label': $localize`Cancelled`, 'value': 'Cancelled' },
          { 'label': $localize`Failed`, 'value': 'Failed' },
          { 'label': $localize`Error`, 'value': 'Error' },
          { 'label': $localize`Purged`, 'value': 'Purged' },
        ];
        return STATUS_OPTIONS_CHECKS.find(option => option.value == value)?.label;
    }
    else{
        const STATUS_OPTIONS_CHECKS = [
          { 'label': $localize`Invited`, 'value': 'Invited' },
          { 'label': $localize`In progress`, 'value': 'In progress' },
          { 'label': $localize`Submitted`, 'value': 'Submitted' },
          { 'label': $localize`Verified`, 'value': 'Verified' },
          { 'label': $localize`Declined`, 'value': 'Declined' },
          { 'label': $localize`Expired`, 'value': 'Expired' },
          { 'label': $localize`Completed`, 'value': 'Completed' },
          { 'label': $localize`Requested`, 'value': 'Requested' },
          { 'label': $localize`Deleted`, 'value': 'Deleted' },
          { 'label': $localize`Stopped`, 'value': 'Stopped' },
          { 'label': $localize`Scheduled`, 'value': 'Scheduled' },
          { 'label': $localize`Sending`, 'value': 'Sending' },
          { 'label': $localize`Cancelled`, 'value': 'Cancelled' },
          { 'label': $localize`Failed`, 'value': 'Failed' },
          { 'label': $localize`Purged`, 'value': 'Purged' },
        ];
        return STATUS_OPTIONS_CHECKS.find(option => option.value == value)?.label;
    }

  }

  getTagInformation(request:any){
    return {
      hasTag: true,
      nestedStatTagText: '',
      tagText: this.getLabelByValue(request.state) ? this.getLabelByValue(request.state) : request.state,
      status: request.state,
      sub_status: request?.sub_state,
      tagCompleted: 0,
      tagTotal: 0,
      pulseCutoffIncomplete: false,
      cancelledBy: '',
      sub_status_tooltip: this.subStatusTooltips
    };
  }


  getRequestedByInfo(request:any){
    return {label: $localize`Requested by`, content: request.requested_by, color:false}
  }

  getCheckNameInfo(request:any){
    const MOBILE_ID_FLOWS = ['ID - 1 doc', 'ID - 1 doc + DVS', 'ID - 2 docs', 'ID - 2 docs + DVS']
    request.updated_check_name = MOBILE_ID_FLOWS.includes(request.check_name.name) ? `MobileID - ${request.check_name.name}` : request.check_name.name;
    if(this.TRUST_752_VERIFICATION &&  request.check_name.flow_name){
        request.updated_check_name = `${request.check_name.name} - ${request.check_name.flow_name}`
    }
    return {label: $localize`Check name`,  content: this.getCheckandProviderNames(request.updated_check_name, request.provider_info.name)}
  }

  getCheckandProviderNames(checkName:string, providerName:string){
    return `${checkName} <span class="color-grey">(${providerName})</span>`;
  }

  onClickName(person_uid:string) {
    this.router.navigate([`/people/profile/${person_uid}`]);
  }

  areDefaultValues() {
    const isSearchOptionDefault = this.searchOption?.length === 0
    const isrowsPerViewDefault = this.rowsPerView === 20
    const iscurrentPageDefault = this.currentPage === 1
    const isSortStringDefault = this.sortString === '-created'
    const isfilterOutputDefault = this.filterOutput === null
    return isSearchOptionDefault && isrowsPerViewDefault && iscurrentPageDefault && isSortStringDefault && isSortStringDefault && isfilterOutputDefault
  }

}
